// ./src/components/features/CreateEventWizard/useTypeIdeas.ts
//
// The event TYPE's own ideas for a feature's step (#62 P6(h)) — a wedding's timeline ("Cake cutting"), a potluck's
// sign-up items ("Dessert") — from the setup catalog (`offers[].options.ideas`). [] when the type has none, the catalog
// is not loaded, or the gateway predates the field (`EventSetupService.refusedIdeas`): the step then shows its generic
// starters (`startersFor`).

import { useOptionalEventSetupCatalogContext } from '@/contexts';

import { useEventWizard } from './WizardContext';

export const useTypeIdeas = (featureCode: string): string[] => {
  const { draft } = useEventWizard();
  const catalog = useOptionalEventSetupCatalogContext();
  const type = catalog?.findType(draft.eventCategoryId) ?? null;

  return type?.offers.find((o) => o.featureCode === featureCode)?.options?.ideas ?? [];
};

/** #140 — the TYPE's gift ideas ("Diapers", "Books") for a gift list; [] when gifts are not usual for it, or not loaded. */
export const useTypeGiftIdeas = (): string[] => {
  const { draft } = useEventWizard();
  const catalog = useOptionalEventSetupCatalogContext();
  const type = catalog?.findType(draft.eventCategoryId) ?? null;

  return type?.gifts?.ideas ?? [];
};
